// make id = `lang:slug`

export const getLearnMoreLinks = (basePath:string, sectionId:string) =>{
    const links:{route:string, slug:string}[] = [];
    LEARN_MORE_DIR.forEach(section =>{
        if(section.id === sectionId){
            section.sub.forEach(topic => {
                links.push({
                    route: basePath + topic.path,
                    slug: renderTitleSlug(sectionId, topic.path),
                })
            })
        }
    })
    return links;
}

const renderTitleSlug = (sectionId:string, route:string) => {
    return [
        'lm_title',
        sectionId,
        route
      ].join(':')
}


const sanitizePaths = () =>{
    const allPaths = [];
    LEARN_MORE_DIR.forEach(section =>{
        section.sub.forEach(topic => {
            topic.path = topic.id;
            // logTitleSlug(section.id, topic.path)
            allPaths.push(section.id +':' + topic.path)
            if (topic.sub){
                topic.sub.forEach(subtopic => {
                    subtopic.path = [topic.path, subtopic.id].join(':');
                    allPaths.push(section.id +':' + subtopic.path)
                    // logTitleSlug(section.id, subtopic.path)
                })
            }
        })
    });
    // console.log('allPaths', allPaths)
}

interface ILearnMoreSection {
    id: string,
    isLocked: boolean,
    sub: ILearnMoreTopic[],
}
interface ILearnMoreTopic {
    id: string,
    caption: string,
    path?:string,
    sub?: ILearnMoreTopic[],   
}

export const LEARN_MORE_DIR:ILearnMoreSection[] = [
    {
        id: 'applicant',
        isLocked: true,
        sub: [
            {caption: 'About the Test', id:'about', sub:[
                {caption:'Will I have to pass the Mathematics Proficiency Test?', id:'for_me'},
                {caption:'What is on the test?', id:'whats_on'},
                {caption:'How do I pass the test?', id:'how_do_i_pass'},
                {caption:'How long do I have to write the test?', id:'how_long'},
                {caption:'How much does it cost to write the test?', id:'cost'},
                {caption:'How many times can I write the test?', id:'how_many_times'},
                {caption:'Who will mark the test?', id:'marking'},

            ]},
            {caption: 'Registering for the Test', id:'register', sub:[
                {caption:'Where do I get my College Application Number?', id:'oct_id'},
                {caption:'Can I create an account if I haven’t received my College Application Number from the OCT?', id:'no_oct_id'},
                {caption:'Where can I take the test?', id:'where'},
                {caption:'When can I register to write the test?', id:'when'},
                {caption:'Can I sign up for more than 1 test session?', id:'register_multiple'},
                {caption:'If I am on the waiting list for one test session currently, am I able to join another test session?', id:'waiting_list_join'},
                {caption:'Can current members of the OCT take the Mathematics Proficiency Test?', id:'current_teachers'},
                {caption:'What do I do if there are no test sessions that fit my schedule?', id:'no_session'},
            ]},
            {caption: 'Preparing for the Test', id:'prepare', sub:[
                {caption:'What is on the test?', id:'whats_on_the_test'},
                {caption:'Sample Questions and Resources', id:'sample_questions'},
            ]},
            {caption: 'Accessibility & Accommodations', id:'access_accomm'},
            {caption: 'On Test Day', id:'testday', sub:[
                {caption:'What should I bring to the test?', id:'bring'},
                {caption:'What happens if I do not bring valid and acceptable photo identification?', id:'photo_id_problem'},
                {caption:'What if the name on my photo identification does not exactly match the name on my Mathematics Proficiency Test account?', id:'photo_id_name'},
                {caption:'What happens on the day of the test?', id:'what_happens'},
                {caption:'What happens if I miss my test session?', id:'miss'},
                {caption:'What if I show up late to my test session?', id:'late'},
                {caption:'Personal Belongings', id:'personals'},

            ]},
            {caption: 'Checking your Results', id:'results', sub:[
                {caption:'How will I know if I passed the test?', id:'passed'},
                {caption:'What are my next steps if I am not yet successful on the test?', id:'not_yet'},
                {caption:'Is it possible to pass one component of the test and not the other?', id:'partial_success'},
            ]},
            {caption: 'F.A.Q. (Test Applicants)', id:'faq'},
        ]
    },
    {
        id: 'testadmin',
        isLocked: true,
        sub: [
            {caption:'About the Test', id:'about'},
            {caption:'Technical Requirements', id:'tech', },
            {caption:'Accessibility & Accommodations', id:'access_accomm', },
            {caption:'Creating Test Sessions', id:'create_test', sub:[
                {caption:'How do I begin?', id:'how_to_begin'},
                {caption:'What is a test window?', id:'test_window'},
                {caption:'How do I create a test session?', id:'create_test_session'},
                {caption:'What is a restricted session?', id:'restricted_session'},
                {caption:'Can I create more than one test session?', id:'multiple_sessions'},
                {caption:'What do I do after I have created the test sessions?', id:'after_creating'},
                {caption:'Adjusting Test Session Capacity', id:'adjusting_capacity'},
            ]},
            {caption:'Applicants Outside the Faculty', id:'outside_faculty'},
            {caption:'Before the Test Day', id:'before'},
            {caption:'On Test Day', id:'on_test_day', sub:[
                {caption:'Starting the Test Session', id:'start'},
                {caption:'Verifying Photo IDs', id:'photo_id'},
                {caption:'If Participants Arrive Late', id:'late'},
                {caption:'Extending the Test Session', id:'extending'},
                {caption:'Closing the Test Session', id:'closing'},
                {caption:'Before Test Takers Leave the Test Location', id:'before_they_leave'},
            ]},
            {caption:'F.A.Q. (Test Administrators)', id:'faq'},
        ]
    },
];


















sanitizePaths();
// temp1.map(t => `'${t}'`+': `\n\n\n`,').join('\n')